/*eslint-disable*/
export default {
    data() {
        return {
            classes: '',
            btn_id: null,
            paydata: null,
            sendingChoices: false,
            profile: null,
            loading: true,
            candidateCounselor: {},
            cycleId: null,
            days: [],
            selectedDays: [],
            selectedDaysList: [],
            remainCount: 0,
            unfitCounselor: '',
            unfitTime: '',
            todoMessage: '',
            showBuyPackage: false,
            canSelect: false,
            dialogRemainTime: false,
            dialogChangeCounselor: false,
            paymentDialog: false,
            successfulPayment: {
                refId: '',
                trCode: '',
            },
            nextSession: {},
            message: '',
            transactionClass: null,
            transactionRefId: null,
            validOrder: false,
            orderInfo: null,
        }
    },
    mounted() {
    },
    methods: {
        prepareDataForWebengageAndSend(resp) {
            this.orderInfo = resp.data
            if (resp.data.msg == "success payment") {
                this.transactionMessage = this.successTitle;
                this.btn_id = 'ga_purchase_successful';
                let order = resp.data.order;
                let conversionRate = resp.data.conversion_rate;
                this.successfulPayment.refId = resp.data.ref_id;


                if (resp.data.newCustomer) {
                    this.classes = 'new-customer';
                }

                let webengageProducts = [];

                order.products.forEach((item, index) => {
                    webengageProducts[`product_id_${(index + 1)}`] = item.id;
                    webengageProducts[`product_name_${(index + 1)}`] = item.title;
                    webengageProducts[`product_discount_${(index + 1)}`] = parseFloat((item.pivot.discount * conversionRate).toFixed(2));
                    webengageProducts[`product_item_count_${(index + 1)}`] = item.pivot.quantity;
                    webengageProducts[`product_price_${(index + 1)}`] = parseFloat((item.pivot.price * conversionRate).toFixed(2));
                    webengageProducts[`product_session_count_${(index + 1)}`] = item.session_count;
                });

                let webEngageData = {
                    currency: 'dollar',
                    isFirstPurchase: (resp.data.newCustomer == true) ? 'new-customer' : 'old-customer',
                    cartsCount: resp.data.cartsCount,
                    cart_id: resp.data.payment.cart_id,
                    coupon_code: resp.data.coupon_code,
                    amount: parseFloat((resp.data.payment.cart_amount * conversionRate).toFixed(2)),
                    ...webengageProducts
                };


                //UNCOMMENT FOR PRODUCTION
                if (!resp.data.event_fired) {
                    this.sendWebEngagePaymentData('purchase', webEngageData);
                    if (resp.data.newCustomer) {
                        this.sendWebEngagePaymentData('first_purchase', webEngageData);
                    }

                    this.paydata = this.pushGa4PurchaseEvent(resp.data);
                }
                this.validOrder = true;

            } else if (resp.data.msg == 'invalid payment') {
                // this.btn_id = 'ga_purchase_failed';
            }
        },
        /**
         * GA4 purchase — only call after backend confirms successful payment.
         * Clears previous ecommerce state, then pushes purchase to dataLayer.
         */
        pushGa4PurchaseEvent(data) {
            const order = data.order || {};
            const payment = data.payment || {};
            const cart = data.cart || {};
            const journey = cart.set_session_journey || data.set_session_journey || null;
            const therapist = this.resolvePurchaseDoctor(data, journey, order);
            const therapistName = this.resolveDoctorDisplayName(therapist);
            const therapistId = therapist && (therapist.id || therapist.user_id || (therapist.user && therapist.user.id));

            const toIrrNumber = (amount) => {
                const value = Number(amount);
                if (!Number.isFinite(value)) return 0;
                const currency = String(data.currency || '').toLowerCase();
                if (currency === 'dollar' || currency === 'usd') {
                    const rate = Number(data.conversion_rate);
                    if (Number.isFinite(rate) && rate !== 0) {
                        return Math.round(value / rate);
                    }
                }
                return Math.round(value);
            };

            const items = (order.products || []).map((item) => {
                const pivot = item.pivot || {};
                const unitPrice = pivot.final_price != null ? pivot.final_price : pivot.price;
                const itemDoctor = this.resolvePurchaseDoctor(data, journey, order, item);
                const doctorName = this.resolveDoctorDisplayName(itemDoctor) || therapistName;
                return {
                    item_id: String(
                        (itemDoctor && (itemDoctor.id || itemDoctor.user_id || (itemDoctor.user && itemDoctor.user.id)))
                        || therapistId
                        || item.id
                        || ''
                    ),
                    // Mapping: ITEM_NAME = therapist name
                    item_name: doctorName || item.title || '',
                    doctor_name: doctorName || '',
                    price: toIrrNumber(unitPrice),
                    quantity: Number(pivot.quantity) || 1,
                    session_type: this.resolvePurchaseSessionType(data, journey, item),
                };
            });

            const transactionId = data.trCode
                || payment.tr_code
                || payment.transaction_id
                || payment.id
                || order.id
                || cart.id;

            const paidValue = toIrrNumber(
                payment.paid_amount != null ? payment.paid_amount : order.subtotal
            );

            const rootDoctorName = therapistName
                || (items[0] && items[0].doctor_name)
                || '';

            // Root-level doctor_name helps GTM variables that don't read item params.
            const purchasePayload = {
                event: 'purchase',
                doctor_name: rootDoctorName,
                ecommerce: {
                    transaction_id: String(transactionId || ''),
                    value: paidValue,
                    currency: 'IRR',
                    items,
                },
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(purchasePayload);

            return purchasePayload;
        },
        resolvePurchaseDoctor(data, journey, order, item) {
            const profile = (this.$store && this.$store.getters && this.$store.getters.getProfile)
                || this.profile
                || null;
            const storeDoctor = this.$store && this.$store.getters && this.$store.getters.getDoctor;
            // Panel users: assigned therapist lives on profile.assignedDoctor (array or object)
            const assignedDoctor = this.resolveAssignedDoctorFromProfile(profile);

            const candidates = [
                // New-user journey checkout
                journey && journey.doctor,
                data && data.doctor,
                data && data.therapist,
                data && data.counselor,
                order && order.doctor,
                order && order.therapist,
                data && data.cart && data.cart.doctor,
                data && data.cart && data.cart.therapist,
                item && item.doctor,
                item && item.therapist,
                item && item.counselor,
                // Existing panel users buying packages/basket/factor
                assignedDoctor,
                profile && profile.doctor,
                profile && profile.therapist,
                storeDoctor,
            ];

            for (let i = 0; i < candidates.length; i++) {
                if (candidates[i]) return candidates[i];
            }
            return null;
        },
        resolveAssignedDoctorFromProfile(profile) {
            if (!profile || !profile.assignedDoctor) return null;
            const assigned = profile.assignedDoctor;
            if (Array.isArray(assigned) && assigned.length > 0) {
                return assigned[0];
            }
            if (typeof assigned === 'object' && assigned !== null) {
                return assigned;
            }
            return null;
        },
        resolveDoctorDisplayName(doctor) {
            if (!doctor) return '';

            // Prefer nested user.full_name first — PaymentStatus uses this path.
            const candidates = [
                doctor.user && doctor.user.full_name,
                doctor.user && doctor.user.name,
                doctor.full_name,
                doctor.name,
            ];

            const first = doctor.firstname || doctor.first_name || doctor.name
                || (doctor.user && (doctor.user.firstname || doctor.user.first_name || doctor.user.name));
            const last = doctor.lastname || doctor.last_name || doctor.family
                || (doctor.user && (doctor.user.lastname || doctor.user.last_name || doctor.user.family));
            if (first || last) {
                // Avoid duplicating when doctor.name was already a full display name
                const combined = [first, last].filter(Boolean).join(' ').trim();
                if (combined && combined !== doctor.name && combined !== doctor.full_name) {
                    candidates.push(combined);
                } else if (combined) {
                    candidates.push(combined);
                }
            }

            for (let i = 0; i < candidates.length; i++) {
                const value = candidates[i];
                if (value != null && String(value).trim() !== '') {
                    return String(value).trim();
                }
            }
            return '';
        },
        resolvePurchaseSessionType(data, journey, item) {
            const candidates = [
                data.session_type,
                data.counseling_type,
                journey && journey.session_type,
                journey && journey.counseling_type,
                journey && journey.category,
                journey && journey.type,
                data.cart && data.cart.session_type,
                item && item.session_type,
                item && item.counseling_type,
                item && item.category,
                journey && journey.doctor && journey.doctor.subtitle,
            ];

            for (let i = 0; i < candidates.length; i++) {
                const value = candidates[i];
                if (value != null && String(value).trim() !== '') {
                    return String(value).trim();
                }
            }
            return '';
        },
        sendWebEngagePaymentData(eventName, data) {
            // console.log(eventName, data, 'done');
            if (window.webengage) {
                window.webengage.track(eventName, data);
            }
        },


    },
}